import React, { Component } from "react";
import { connect } from "react-redux";
import { Sticky } from "react-sticky";

class Section extends Component {
  render() {
    const { label, shouldShow, action, children, isStaffApp } = this.props;

    if (shouldShow || action === "edit") {
      return (
        <div>
          {
            !isStaffApp &&
            <h3 className="mt-3 profile-header">{label}</h3>
          }
          {children}
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    shouldShow: Object.keys(ownProps.resources).reduce((acc, resource) => {
      return acc || ownProps.resources[resource].reduce((acc, key) => {
        const value = state[resource][key]
        if (Array.isArray(value)) {
          return acc || value.length > 0
        }
        return acc || Boolean(value) || (value !== null && value !== "" && value !== 0)
      }, false)
    }, false),
    action: state.ui.action
  }
}

export default connect(mapStateToProps)(Section);
